<template>
  <section
    v-show="showTooltip && x && y"
    class="tooltip"
    :style="`transform: ${tooltipTransform}`">
    <header class="header">
      <h3 class="title">
        {{ title }}
      </h3>

      <button
        aria-label="Close Tooltip"
        class="dismiss-tooltip-button"
        @click="closeTooltip">
        &times;
      </button>
    </header>

    <table class="top-line-table">
      <thead class="candidates-table-headers">
        <tr>
          <th class="text-left">
            {{ $t("message.candidate").toUpperCase() }}
          </th>
          <th class="text-center">
            {{ $t("message.votes").toUpperCase() }}
          </th>
          <th class="text-right">
            {{ $t("message.percentAbbreviation").toUpperCase() }}
          </th>
        </tr>
      </thead>

      <tbody>
        <tr
          v-for="candidate of candidates"
          :key="candidate.name"
          class="candidates-table-row"
          :style="`font-weight: ${candidate.winner ? 'bold' : 'normal'};`">
          <td class="tooltip-td candidate-text">
            {{ candidate.name }}
          </td>
          <td class="tooltip-td votes-text">
            {{ commas(candidate.votes) }}
          </td>
          <td
            class="tooltip-td percent-text"
            :style="`background-color: ${candidate.color}; color: ${readableColor(hexOrVarToHex(candidate.color))}; text-align: center; padding: 0 5px`">
            {{ candidate.percentage.toFixed(2) }}%
          </td>
        </tr>
      </tbody>
    </table>

    <footer class="table-precincts">
      {{ footer }}
    </footer>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { commas } from "@/filters";
import { readableColor } from "../../helpers/readableColor";
import { hexOrVarToHex } from "../../helpers/utils";

const props = {
  tooltipAlwaysLeft: {
    default: false,
    required: true,
    type: Boolean,
  },
  tooltipAlwaysTop: {
    default: false,
    required: true,
    type: Boolean,
  },
};

const computed = {
  ...mapGetters({
    candidates: "tooltip/candidates",
    footer: "tooltip/footer",
    showTooltip: "tooltip/show",
    title: "tooltip/title",
    x: "tooltip/x",
    y: "tooltip/y",
    isLeftOfMapCenter: "tooltip/isLeftOfMapCenter",
    isAboveMapCenter: "tooltip/isAboveMapCenter",
  }),
  tooltipWidth() {
    // eslint-disable-next-line no-unused-vars
    const _watchXForChanges = this.x;

    return this.$el?.clientWidth || 0;
  },
  tooltipHeight() {
    // eslint-disable-next-line no-unused-vars
    const _watchYForChanges = this.y;

    return this.$el?.clientHeight || 0;
  },
  tooltipTransform() {
    const margin = 20;
    const xPosition =
      !this.tooltipAlwaysLeft && this.isLeftOfMapCenter
        ? this.x + margin
        : this.x - margin - this.tooltipWidth;

    const yPosition =
      this.isAboveMapCenter && !this.tooltipAlwaysTop
        ? this.y - 50
        : this.y - this.tooltipHeight + 50;

    return `translate(${xPosition}px, ${yPosition}px)`;
  },
};
const methods = {
  readableColor,
  hexOrVarToHex,
  ...mapActions(["setGeoSelection"]),
  ...mapActions({
    hideTooltip: "tooltip/hideTooltip",
  }),
  showDisableButton() {
    return window.Touch;
  },
  closeTooltip() {
    this.hideTooltip();
    this.setGeoSelection(null);
  },
  candidateBackgroundColor(candidate) {
    return candidate.winner ? `${candidate.color}33` : "#eee";
  },
  commas,
};
export default {
  props,
  computed,
  methods,
};
</script>

<style scoped>
.tooltip {
  background-color: var(--white);
  position: absolute;
  left: 0;
  top: 0;
  border: 2px solid #d8d8d8;
  padding: 15px;
  pointer-events: none;
  width: 350px;
  z-index: 99999999999999;
}
.header {
  align-items: center;
  display: inline-flex;
  justify-content: space-between;
  width: 100%;
}
.dismiss-tooltip-button {
  align-items: center;
  align-self: flex-start;
  border-radius: 50%;
  cursor: pointer;
  display: inline-flex;
  font-size: 1.25rem;
  height: 1.5rem;
  justify-content: center;
  line-height: 1.5rem;
  pointer-events: all;
  text-align: center;
  width: 1.5rem;
}
.title {
  font-weight: 900;
  text-align: start;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 10px;
}
tr {
  padding: 0.25em;
}

.candidate-text {
  color: var(--primary-color);
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 25px;
}

.votes-text {
  color: #000;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
}

.percent-text {
  text-align: center;
  font-size: 14px;
  font-weight: 600;
}
</style>
